export default __webpack_public_path__ + "static/media/warning--pass-left-or-right--g2.b55dff44.png";